import { fetch } from '@atlassian/eoc-fetch';
import { withReportingPrefix } from '../../common/utils';
import { opsReportsErrorTransformer as errorTransformer } from './utils';
export const getDashboards = () => fetch(withReportingPrefix('/v5/reports/dashboards'), {
  exactUrl: true,
  errorTransformer
});
export const getDashboardsV3 = () => fetch(withReportingPrefix('/v3/reports/dashboards'), {
  exactUrl: true,
  errorTransformer
});
export const getReportSettings = () => fetch(withReportingPrefix('/v3/reports/index'), {
  exactUrl: true,
  errorTransformer
});
export const getSsoEmbedUrlEndpoint = (isDarkMode, dashboardId, teamId) => {
  const queryParam = teamId ? {
    theme: isDarkMode ? 'DarkMode' : '',
    dashboardId,
    teamId,
    // Adding time as queryParam to avoid browser caching
    // Should ideally be handled by "Cache-Control" header from server
    _: Date.now().toString()
  } : {
    theme: isDarkMode ? 'DarkMode' : '',
    dashboardId: dashboardId,
    _: Date.now().toString()
  };
  const url = `/v3/reports/dashboard?${new URLSearchParams(queryParam).toString()}`;
  return fetch(withReportingPrefix(url), {
    exactUrl: true,
    errorTransformer
  });
};
export const getReportRights = teamId => {
  let url = '/v3/reports/rights';
  if (teamId) {
    url += `?teamId=${teamId}`;
  }
  return fetch(withReportingPrefix(url), {
    exactUrl: true,
    errorTransformer
  });
};
export const getAVPEmbedTokens = (dashboardId, teamId) => {
  let url = '/v3/reports/embed-token';
  return fetch(withReportingPrefix(url), {
    exactUrl: true,
    method: 'POST',
    body: {
      dashboardId,
      teamId
    },
    errorTransformer
  });
};